import { Component, OnInit, HostListener, Input } from '@angular/core';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit {

  windowsWidth;
  buttonShare = false;

  @Input() bgColor = '#f6f6f6';
  @Input() twitterText = '';

  currentUrl = '';

  constructor() { }

  ngOnInit() {
    this.windowsWidth = window.innerWidth;
    this.currentUrl = window.location.href;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.windowsWidth = window.innerWidth;
  }

  shareButton() {
    this.buttonShare = !this.buttonShare;
    if (this.buttonShare === true) {
      document.getElementById('sharePopupBar').style.display = 'flex';
    } else {
      document.getElementById('sharePopupBar').style.display = 'none';
    }
  }

}
